import type { TFunction } from 'i18next'
import { petDefaultIdCardImage } from '@/shared/assets'
import { formatDate } from '@/shared/helpers/format-date'
import { WEIGHT_OPTIONS } from '@/pages/onboarding/pet/form/page.onboarding.pet-form.hook'
import type { Pet, Policy } from '@/shared/types/global.types'

export type PetClaimCard = {
  petName: string
  photoUrl: string
  hidePhotoBackground: boolean
  ownerName: string
  policyId: string
  startDate: string
  birthday?: string
  weightLabel?: string
  vetName?: string
}

// Data for the pet id card shown next to the create and edit claim forms
export function buildPetClaimCard(
  t: TFunction,
  pet: Pet | undefined,
  policy: Policy | undefined,
  ownerName: string,
): PetClaimCard {
  const weightKey = WEIGHT_OPTIONS.find(
    (option) => option.value === pet?.weight,
  )?.key
  return {
    petName: pet?.name ?? '',
    // The API can send an empty string when the pet has no picture
    photoUrl: pet?.petPictureUrl || petDefaultIdCardImage,
    hidePhotoBackground: !pet?.petPictureUrl,
    ownerName,
    policyId: `#${policy?.policyExternalId ?? ''}`,
    startDate: formatDate(policy?.startDate),
    birthday: pet?.birthDate ? formatDate(pet.birthDate) : undefined,
    weightLabel: weightKey
      ? t(`onboarding.pet.form.stepOne.weightOptions.${weightKey}`)
      : undefined,
    vetName: pet?.primaryVetName,
  }
}
